/**
 * Gets the currently configured API base URL from settings
 */
export const getApiBaseUrl = () => {
  try {
    // Try to get from the settings structure first
    const savedSettings = localStorage.getItem('api_settings');
    if (savedSettings) {
      const parsedSettings = JSON.parse(savedSettings);
      const activeId = parsedSettings.activeEndpointId;
      const activeEndpoint = parsedSettings.endpoints.find(e => e.id === activeId);
      if (activeEndpoint) {
        return activeEndpoint.url;
      }
    }
    
    // Fall back to legacy storage method
    const configuredUrl = localStorage.getItem('api_base_url');
    if (configuredUrl) {
      return configuredUrl;
    }
  } catch (error) {
    console.error('Error retrieving API URL from settings:', error);
  }
  
  // Default fallback
  return process.env.REACT_APP_API_URL || 'https://pacehere.com';
};

/**
 * Resolves a URL to ensure it uses the correct base URL if needed
 * @param {string} url - The URL to resolve
 * @returns {string} - The resolved URL
 */
export const resolveUrl = (url) => {
  if (!url) return url;
  
  // If it's already an absolute URL not pointing to our API, return as is
  if (url.startsWith('http://') || url.startsWith('https://')) {
    // Check if this URL is pointing to our API but possibly with a different base
    const apiPathMatch = url.match(/https?:\/\/[^/]+(\/api\/.+)/);
    if (!apiPathMatch) {
      return url; // Not our API, return as is
    }
    
    // Extract the API path and rebase it
    const apiPath = apiPathMatch[1];
    return `${getApiBaseUrl()}${apiPath}`;
  }
  
  // It's a relative URL, prepend the base URL
  if (url.startsWith('/')) {
    return `${getApiBaseUrl()}${url}`;
  }
  
  // Add leading slash if missing
  return `${getApiBaseUrl()}/${url}`;
};
